import React, { useState, useEffect } from 'react';
import "./History.css";
import axios from 'axios';
import IntroTemplate from "../../components/IntroTemplate/IntroTemplate";
import AllIndustries from "../../components/ProductList/AllIndustries";
import PhotoSlider from '../../components/CompanyJourney/CompanyTimelineGrid';
import HomeBlog from '../../components/HomeBlog/HomeBlog';
import { getStoredData } from '../../JsonFiles/fetchData';

const History = () => {
  const data = getStoredData()?.["15"] ?? {};
  const [products, setProducts] = useState([]);
  const [blogs, setBlogs] = useState([]);

  // Fetch products on component mount
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          "https://shahbad-enterprises-backend.vercel.app/products"
        );
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    const fetchBlogs = async () => {
      try {
        const response = await axios.get(
          "https://avenue-website-backend.vercel.app/blog"
        );
        setBlogs(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
    fetchBlogs();
  }, []);

  return (
    <div className="history-container">
      <IntroTemplate logo={data.logo} title={data.title} image={data.image} />
      <PhotoSlider cards={data.Timeline} />
      <AllIndustries 
        products={products} 
        title={data.Producttitle} 
        details={data.Productdetails} 
        link={data.Productlink} 
        linktext={data.Productlinktext} 
      />
      <HomeBlog
        title={data.HomeBlogTitle}
        link={data.HomeBlogLink}
        text={data.HomeBlogText}
        blogs={blogs}
      />
    </div>
  );
};

export default History;
